import { CommonSchemaIds } from '../../schemas/common.const.js';
export const dictionary = {
    schema: {
        [CommonSchemaIds.VISIBLE]: {
            title: 'Visibility',
            options: {
                visible: 'Visible',
                hidden: 'Hidden'
            }
        },
        [CommonSchemaIds.CHART_TYPE]: {
            title: 'Chart type'
        }
    }
};
